
import SectionTitle from '../section-title.vue'

export default {
  components: {SectionTitle},
  props: {
    title: {type: String, default: undefined},
    required: {type: Boolean, default: false},
    tooltip: {type: String, default: undefined}
  },
}

